import * as ko from "knockout";
import entityBase from "entityBase";

export class service_model_dto extends entityBase {
  service_model_id: KnockoutObservable<string>;
  service_model_description: KnockoutObservable<string>;

  constructor(item: any) {
    super();
    this.service_model_id = ko.observable(item?.service_model_id);
    this.service_model_description = ko.observable(item?.service_model_description);
  }
}
